import { handleActions } from 'redux-actions';
import { stepDialogOpen, stepDialogUpdated, stepDialogClose } from '../actions';

const initialState = {
    step: {},
    open: false,
    nextSteps: [],
};

export default handleActions(
    {
        [stepDialogOpen]: (state, action) => {
            return {
                ...state,
                open: !state.open,
                ...action.payload,
            };
        },
        [stepDialogUpdated]: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        [stepDialogClose]: () => initialState,
    },
    initialState,
);
